import { NarrativeDisclaimerBadge } from '@/pages/Narrative/components/NarrativeDisclaimerBadge';
import { FragmentOf, gql } from '@/utilities/gql';
import { NarrativeAuthorBase } from './components/NarrativeAuthorBase';
import { NarrativeAuthorAvatar } from './components/NarrativeAuthorAvatar';

export const NARRATIVE_AUTHOR_FRAGMENT = gql(`
  fragment NarrativeAuthorFields on SwsAuthor @_unmask {
    displayName
    imageUrl
    name
    role
  }
`);

type Props = {
  author: FragmentOf<typeof NARRATIVE_AUTHOR_FRAGMENT>;
  userHoldsPosition?: boolean | null;
};

export const NarrativeAuthor = ({ author, userHoldsPosition }: Props) => {
  const { displayName, imageUrl, name, role } = author;

  return (
    <NarrativeAuthorBase
      title={displayName || name}
      subtitle={role !== '' ? role : 'Community Contributor'}
      badge={<NarrativeDisclaimerBadge userHoldsPosition={userHoldsPosition} />}
    >
      <NarrativeAuthorAvatar
        size="md"
        author={{
          displayName,
          imageUrl,
          name,
        }}
      />
    </NarrativeAuthorBase>
  );
};
